/**
 * Main Initialization
 */
document.addEventListener('DOMContentLoaded', () => { 
  initializeBankPromotion(1);
  document.addEventListener('line-item:change:end', () => initializeBankPromotion(2));
});

/**
 * Orchestrator: Gathers logic from separate functions and updates cart once.
 */
async function initializeBankPromotion(num) {
  console.log(`initializeBankPromotion ${num}`);

  const bankCheckboxes = document.querySelectorAll('.bank-promotion-input');
  const cart = await getCartAttributes();
  
  // 1. Get Add-on changes
  const updates = getAddonUpdates(cart);

  // 2. Get Bank Attribute changes
  const attributes = getBankAttributes(cart, bankCheckboxes);

  // 3. Handle Loading UI
  const bankPromotionList = document.querySelector(".bank-promotion-list"); 
  if(bankPromotionList?.classList.contains("loading")) { 
    bankPromotionList.classList.remove("loading"); 
  }

  // 4. Update if either logic function returned changes
  if (updates || attributes) {
    console.log('Syncing Cart changes...', { updates, attributes });
    await updateCartData(attributes, updates);
    return; // updateCartData re-initializes bank promotion
  }

  // 5. Setup event listeners for manual interaction
  setupEventListeners(bankCheckboxes, bankPromotionList);
}

/**
 * LOGIC FUNCTION: Add-on Product
 * @returns {Object|null} Updates object or null if no change needed
 */
function getAddonUpdates(cart) {
  // 1. Try to get the fresh quantity from the updated HTML first
  const dataEl = document.querySelector('#BagInternalData');
  
  const addonVariantId = dataEl ? dataEl.dataset.addonId : window.addonVariantId;
  const targetQty = dataEl ? parseInt(dataEl.dataset.totalBags) : (window.addonVariantQty || 0);
  console.log(targetQty);
  // const addonVariantId = window.addonVariantId;
  // const targetQty = window.addonVariantQty || 0; 
  if (!addonVariantId) return null;

  const cartItems = cart.items || [];
  const addonItem = cartItems.find(item => item.id == addonVariantId);
  const currentQtyInCart = addonItem ? addonItem.quantity : 0;
  
  // Total items excluding the add-on itself
  const otherItemsCount = cartItems.length - (addonItem ? 1 : 0);

  // 1. If cart is empty (no other items), the addon must be removed (qty 0)
  if (otherItemsCount === 0 && currentQtyInCart > 0) {
    console.log('Removing add-on: Cart has no other items.');
    return { [addonVariantId]: 0 };
  } 
  
  // 2. If cart has other items, ensure addon matches the targetQty
  else if (otherItemsCount >= 1 && currentQtyInCart !== targetQty) {
    console.log(`Updating add-on quantity: Current ${currentQtyInCart} -> Target ${targetQty}`);
    return { [addonVariantId]: targetQty };
  }

  return null;
}

/**
 * LOGIC FUNCTION: Bank Promotions
 * @returns {Object|null} Attributes object or null if no change needed
 */
function getBankAttributes(cart, bankCheckboxes) {
  if (bankCheckboxes.length === 0) return null;

  const cartSelectedBankCode = cart.attributes['_BankCode'] || '';
  const checkedCheckbox = Array.from(bankCheckboxes).find(checkbox => checkbox.checked);
  
  const currentCartToken = getCleanCartToken(); 
  const lastPreselectedCartToken = getCookie('bankSelected');

  // Case: New cart session - Preselect first bank
  if (lastPreselectedCartToken !== currentCartToken && !checkedCheckbox) {
    const first = bankCheckboxes[0];
    first.checked = true;
    return {
      _BankCode: first.value,
      _BankCampaignId: first.dataset.campaignId || ''
    };
  }

  // Case: Manual selection in UI differs from Cart attribute
  if (checkedCheckbox && checkedCheckbox.value !== cartSelectedBankCode) {
    return {
      _BankCode: checkedCheckbox.value,
      _BankCampaignId: checkedCheckbox.dataset.campaignId || ''
    };
  }

  // Case: No checkbox selected but cart still has data - Clear it
  if (!checkedCheckbox && cartSelectedBankCode) {
    return { _BankCode: '', _BankCampaignId: '' };
  }

  return null;
}

/**
 * Manual UI event listener setup
 */
function setupEventListeners(bankCheckboxes, bankPromotionList) {
  const bankPriceToggle = document.querySelector('.bank-price-toggle');
  if (!bankPriceToggle) return;

  const newToggle = bankPriceToggle.cloneNode(true);
  bankPriceToggle.parentNode.replaceChild(newToggle, bankPriceToggle);

  newToggle.addEventListener('change', async event => {
    const checkbox = event.target.closest('.bank-promotion-input'); 
    if (!checkbox) return; 

    if (checkbox.checked) { 
      if(bankPromotionList) bankPromotionList.classList.add("loading"); 
      bankCheckboxes.forEach(cb => { if (cb !== checkbox) cb.checked = false; });
      await updateCartData({
        _BankCode: checkbox.value,
        _BankCampaignId: checkbox.dataset.campaignId || ''
      }, null);
    } else {
      await updateCartData({ _BankCode: '', _BankCampaignId: '' }, null);
    }
  });
}

/**
 * Perform AJAX update
 */
async function updateCartData(attributes, updates) {
  try {
    const payload = {};
    if (attributes) payload.attributes = attributes;
    if (updates) payload.updates = updates;

    const response = await fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    // Check for errors
    if (data.message && data.message.includes('Cart Validation Error:')) {
      renderError(data.message);
      return;
    }

    // Set cookie to prevent re-auto-selecting for this cart ID
    setCookie('bankSelected', getCleanCartToken(), 7);

    // Refresh theme UI
    await new Promise(resolve => {
      const handler = () => {
        document.documentElement.removeEventListener('cart:refresh:end', handler);
        resolve();
      };
      document.documentElement.addEventListener('cart:refresh:end', handler);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });

    await initializeBankPromotion(3);
  } catch (err) {
    console.error('Update failed', err);
  }
}

/**
 * UI: Render Error Message
 */
function renderError(message) {
  const container = document.querySelector('.message-box-container');
  if (!container) return;
  const errorBox = document.createElement('div');
  errorBox.className = 'alert';
  errorBox.innerHTML = `<div class="alert-message"><div>${message}</div></div>`; 
  const title = container.querySelector('div');
  title ? title.insertAdjacentElement('afterend', errorBox) : container.appendChild(errorBox);
}

/**
 * API: Get Cart
 */
async function getCartAttributes() {
  try {
    const response = await fetch('/cart.js');
    return await response.json();
  } catch (error) {
    return { attributes: {}, items: [] };
  }
}

/**
 * UTILS: Cookies & Tokens
 */
function setCookie(n, v, d) {
  let e = '';
  if (d) {
    const date = new Date();
    date.setTime(date.getTime() + d * 24 * 60 * 60 * 1000);
    e = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${n}=${v || ''}${e}; path=/`;
}

function getCookie(n) {
  const nameEQ = `${n}=`;
  const ca = document.cookie.split(';');
  for (let c of ca) {
    c = c.trim();
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function getCleanCartToken() {
  const raw = getCookie('cart') || '';
  return raw.split('%3F')[0].split('?')[0];
}